import { createAsyncActionType } from './index';

export const GET_TESTIMONIALS = createAsyncActionType(
  'testimonials',
  'GET_TESTIMONIALS'
);
